// extracted by mini-css-extract-plugin
export default {"LinkSectionContainer":"LinkSection_LinkSectionContainer__uBleF","Link":"LinkSection_Link__Xmy6g"};